import React, { useEffect } from "react";
import { Outlet, useLocation, matchPath } from "react-router-dom";
import Copyright from "./Copyright/Copyright";

const Main = () => {
  const location = useLocation();

  // const screensHideFooter = ["/quest/details/multiple/choice/:id"];
  const screensHideFooter = [
    "/register",
    "/sign-in",
    "/verify-otp",
    "/qr-scan",
    "/quest/details/completed",
    "/quest/details/multiple/choice/:id",
    "/preview",
  ];

  const screensWithViewportFooter = [
    "/profile/withdraw/success",
    "/quest/details/completed",
  ];

  const screensWithTransparentFixedFooter = [
    // "/quest/details/multiple/choice/:id",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const shouldHideFooter = () => {
    return screensHideFooter?.some((pattern) => {
      if (pattern.includes(":")) {
        return matchPath({ path: pattern }, location.pathname);
      }
      return location.pathname === pattern;
    });
  };
  const shouldUseViewportFooter = () => {
    return screensWithViewportFooter?.some((pattern) => {
      if (pattern.includes(":")) {
        return matchPath({ path: pattern }, location.pathname);
      }
      return location.pathname === pattern;
    });
  };
  const shouldUseTransparentFixedFooter = () => {
    return screensWithTransparentFixedFooter?.some((pattern) => {
      if (pattern.includes(":")) {
        return matchPath({ path: pattern }, location.pathname);
      }
      return location.pathname === pattern;
    });
  };

  const hideFooter = shouldHideFooter();
  const useViewportFooter = shouldUseViewportFooter();
  const useTransparentFixedFooter = shouldUseTransparentFixedFooter();

  return (
    <div className=" flex flex-col h-full w-full max-w-[480px] mx-auto ">
      <div
        className={`${
          useViewportFooter
            ? "flex-1 min-h-0 pb-[50px]"
            : "flex-1 min-h-0 pb-[50px]"
        } ${useTransparentFixedFooter ? "pb-[50px]" : ""}`}
      >
        <Outlet />
      </div>

      {!hideFooter && (
        <div
          className={`${
            useTransparentFixedFooter
              ? "fixed bottom-0 left-0 right-0 z-10"
              : "fixed bottom-0 left-0 right-0 z-10"
          } flex justify-center items-center w-full   z-40 footer `}
          // style={{ boxShadow: "0 -40px 40px -40px rgba(0, 0, 0, 0.01)" }}
        >
          <Copyright
            backgroundClass={
              useTransparentFixedFooter
                ? "bg-transparent"
                : useViewportFooter
                ? "bg-[#ECEEFF]"
                : "bg-white"
            }
          />
        </div>
      )}
    </div>
  );
};

export default Main;
